var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initialized ? _c('div', {
    staticClass: "preview"
  }, [_vm.fullscreen ? _c('v-btn', {
    staticClass: "close-preview",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closePreview
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _vm.isPreviewEnabled && !_vm.isCustomHtmlTab && _vm.products.length > 1 && !_vm.isSelfServe ? _c('v-row', {
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-menu', {
    attrs: {
      "bottom": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({
          staticClass: "pt-2 d-flex align-center",
          attrs: {
            "color": "primary",
            "dark": ""
          }
        }, 'div', attrs, false), on), [_c('span', {
          staticClass: "label"
        }, [_vm._v(_vm._s(_vm.$t('preview_product_label')))]), _c('span', {
          staticClass: "product-name pl-3 font-weight-bold"
        }, [_vm._v(_vm._s(_vm.previewProduct.name)), _c('v-icon', {
          attrs: {
            "color": "#0789b2"
          }
        }, [_vm._v("mdi-menu-down")])], 1)])];
      }
    }], null, false, 3145963966)
  }, [_c('v-list', [_vm._l(_vm.products, function (product, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function click($event) {
          return _vm.selectPreviewProduct(product);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(product.name))])], 1);
  }), _vm.products.length >= 5 ? _c('v-list-item', {
    on: {
      "click": function click($event) {
        _vm.searchProductModal = true;
      }
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('search_another_product')))])], 1)], 1) : _vm._e()], 2)], 1)], 1) : _vm._e(), _vm.showResultSelector || _vm.showLanguageSelector || _vm.showCountrySelector ? _c('div', {
    staticClass: "mt-5 mb-3"
  }, [_vm.showResultSelector ? _c('v-row', {
    staticClass: "mb-3",
    attrs: {
      "justify": "center",
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    class: _vm.showCountrySelector ? 'dropdown-wide' : 'dropdown'
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "items": _vm.results,
      "item-text": "name",
      "item-value": "key",
      "solo": "",
      "dense": ""
    },
    model: {
      value: _vm.previewResult,
      callback: function callback($$v) {
        _vm.previewResult = $$v;
      },
      expression: "previewResult"
    }
  })], 1)], 1) : _vm._e(), _vm.showLanguageSelector || _vm.showCountrySelector ? _c('v-row', {
    class: {
      'flex-column': !(_vm.showLanguageSelector && _vm.showCountrySelector)
    },
    attrs: {
      "justify": "center",
      "align": "center",
      "no-gutters": ""
    }
  }, [_vm.showLanguageSelector ? _c('v-col', {
    class: _vm.showCountrySelector ? 'dropdown-paired' : 'dropdown'
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "items": _vm.enabledLanguages,
      "item-text": "name",
      "item-value": "key",
      "solo": "",
      "dense": "",
      "label": _vm.$t('language')
    },
    model: {
      value: _vm.previewLanguage,
      callback: function callback($$v) {
        _vm.previewLanguage = $$v;
      },
      expression: "previewLanguage"
    }
  })], 1) : _vm._e(), _vm.showCountrySelector ? _c('v-col', {
    class: _vm.showLanguageSelector ? 'dropdown-paired' : 'dropdown'
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "items": _vm.countries,
      "item-text": "description",
      "item-value": "key",
      "solo": "",
      "dense": "",
      "label": _vm.$t('preview_country')
    },
    model: {
      value: _vm.previewCountry,
      callback: function callback($$v) {
        _vm.previewCountry = $$v;
      },
      expression: "previewCountry"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm.isPreviewEnabled && _vm.hasElabelWidget ? _c('p', {
    staticClass: "elabel-lang-hint"
  }, [_vm._v(_vm._s(_vm.$t('preview_elabel_untranslated_hint')))]) : _vm._e(), _c('div', {
    staticClass: "phone-ctn",
    class: {
      'mt-15': !_vm.isPreviewEnabled,
      'fullscreen': _vm.fullscreen
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/iphone-frame.png")
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPreviewEnabled || _vm.isCustomHtmlTab,
      expression: "isPreviewEnabled || isCustomHtmlTab"
    }],
    staticClass: "phone-header font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.pageTitle) + " ")]), _c('div', {
    staticClass: "phone-content"
  }, [_vm.isCustomHtmlTab && _vm.customHtmlContent ? _c('iframe', {
    ref: "customHtmlIframe",
    staticClass: "custom-html-preview-frame",
    attrs: {
      "srcdoc": _vm.customHtmlContent,
      "sandbox": "allow-scripts"
    }
  }) : _vm.isCustomHtmlTab ? _c('div', {
    staticClass: "preview-disabled"
  }, [_c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.$t('custom_html_preview_empty')))])]) : _vm.isPreviewEnabled ? _c('iframe', {
    attrs: {
      "src": _vm.iframeUrl
    }
  }) : _c('div', {
    staticClass: "preview-disabled"
  }, [_vm.needToUpdateRedirection ? _c('div', [_vm.needToUpdateRedirection === 'product' ? _c('div', [_c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.$t('preview_unavailable'))), _c('br'), _c('br'), _vm._v(" " + _vm._s(_vm.$t('preview_unavailable_redirect')))]), _c('br')]) : _vm._e(), _vm.needToUpdateRedirection === 'url' ? _c('div', [_c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.$t('preview_unavailable')) + " " + _vm._s(_vm.$t('preview_unavailable_check_url')))]), _c('br'), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.redirectUrl
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('preview_unavailable_go_to_url')))])], 1)]) : _vm._e()]) : _c('div', [_vm.redirectionMode === 'product' ? _c('div', [_c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.$t('preview_unavailable'))), _c('br'), _c('br'), _vm._v(" " + _vm._s(_vm.$t('preview_unavailable_redirect')))])]) : _vm._e(), _vm.redirectionMode === 'url' ? _c('div', [_c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.$t('preview_unavailable')) + " " + _vm._s(_vm.$t('preview_unavailable_check_url')))]), _c('br'), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.redirectUrl
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('preview_unavailable_go_to_url')))])], 1)]) : _vm._e()])])])]), _vm.isPreviewEnabled ? _c('v-btn', {
    staticClass: "font-weight-bold mt-1",
    attrs: {
      "left": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.displayPreviewModal
    }
  }, [_c('v-icon', [_vm._v("$preview")]), _vm._v(" " + _vm._s(_vm.$t('preview_title')) + " ")], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "500"
    },
    model: {
      value: _vm.searchProductModal,
      callback: function callback($$v) {
        _vm.searchProductModal = $$v;
      },
      expression: "searchProductModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('search_product_title')))]), _c('v-card-text', {
    staticClass: "pa-5"
  }, [_c('v-autocomplete', {
    attrs: {
      "persistent-hint": "",
      "no-filter": "",
      "hint": _vm.hasManyCampaigns ? _vm.$t('search_product_hint') : '',
      "label": _vm.$t('search_product_placeholder'),
      "items": _vm.modalProducts,
      "search-input": _vm.search,
      "item-text": "name",
      "no-data-text": _vm.$t('no_result_found'),
      "return-object": "",
      "loading": _vm.loadingProducts
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.search = $event;
      }
    },
    model: {
      value: _vm.modalPreviewProduct,
      callback: function callback($$v) {
        _vm.modalPreviewProduct = $$v;
      },
      expression: "modalPreviewProduct"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.searchProductModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.selectProductInModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('select')))])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": _vm.isTokenRefreshForced ? 300 : 700
    },
    model: {
      value: _vm.previewModal,
      callback: function callback($$v) {
        _vm.previewModal = $$v;
      },
      expression: "previewModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.previewModalTitle))]), _vm.isTokenRefreshForced ? _c('v-row', {
    staticClass: "ma-4",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), !_vm.isTokenRefreshForced ? _c('v-card-text', [_c('div', {
    staticClass: "qrcode-ctn"
  }, [_c('div', {
    staticClass: "hint font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('preview_code_testing_purposes')))]), _vm.isAvailable('editor:authentication') ? _c('v-row', {
    staticClass: "ma-0 mb-2",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "result-select shrink"
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "items": _vm.results,
      "item-text": "name",
      "item-value": "key",
      "solo": "",
      "dense": ""
    },
    model: {
      value: _vm.previewResult,
      callback: function callback($$v) {
        _vm.previewResult = $$v;
      },
      expression: "previewResult"
    }
  })], 1)], 1) : _vm._e(), _c('v-col', {
    staticClass: "qr-content"
  }, [_c('qrcode-vue', {
    staticClass: "qr-content",
    attrs: {
      "value": "".concat(_vm.iframeUrl, "&banner=true"),
      "size": _vm.qrCodeSize,
      "level": "H"
    }
  })], 1)], 1)]) : _vm._e(), !_vm.isTokenRefreshForced ? _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.previewModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('dismiss')))])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }